import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-second-main-slide',
  templateUrl: './second-main-slide.component.html',
  styleUrls: ['./second-main-slide.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecondMainSlideComponent implements OnInit {
  @Input()
  text!: string;
  @Input()
  title!: string;
  constructor() {}

  ngOnInit(): void {}
}
